export default "__VITE_PUBLIC_ASSET__85e163e3__"